<template>
  <div>
    <header-logos></header-logos>
    <v-app-bar class="mt-6" color="white" flat>
      <v-btn @click="irAtras" icon>
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <v-toolbar-title>Publicación</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn outlined @click="printPublication()">
        <v-icon left>mdi-printer</v-icon>
        Imprimir Publicación
      </v-btn>
    </v-app-bar>
    <v-container v-if="publicacion" class="mt-6 mb-6">
      <v-row class="mb-6">
        <v-col class="text-center" cols="12">
          <h1
            class="mb-4"
            style="
              font-weight: 700;
              font-size: 50pt;
              font-family: 'Roboto Condensed', sans-serif;
            "
          >
            {{ publicacion.Name.es }}
          </h1>
          <p v-if="municipio" style="font-size: 35pt; font-weight: 300">
            Municipio {{ municipio.Name }}
          </p>
          <!-- <div>
            <v-btn class="ma-2" outlined @click="selectMunicipioDialog = true">
              Cambiar Ubicación
            </v-btn>
          </div> -->
        </v-col>
      </v-row>
      <div>
        <!-- INTRODUCTION -->
        <v-row>
          <v-col cols="6">
            <v-img :src="publicacion.Data.LinkImage" aspect-ratio="1.4"></v-img>
          </v-col>
          <v-col cols="6">
            <p
              style="
                font-size: 22pt;
                line-height: 38px;
                color: #9e9e9e;
                font-weight: 600;
              "
            >
              {{ publicacion.Introduction.es }}
            </p>
          </v-col>
        </v-row>
        
        <!-- BODY -->
        <div>
          <div style="display: flex; align-items: baseline">
            <v-icon x-large class="mr-3" color="black">
              mdi-information-outline
            </v-icon>
            <p class="mb-0" style="font-size: 30pt; font-weight: 600">
              {{publicacion.Data.InitialTitle.es}}
            </p>
          </div>
          <v-row class="mt-1 mb-4">
            <v-col cols="12">
              <div
                style="column-count: 2; font-size: 14pt"
                v-html="publicacion.Body.es.First"
              ></div>
            </v-col>
          </v-row>
        </div>

        <!-- CLIMA -->
        <div v-if="publicacion.EscenariosClimaticos.Show">
          <div style="display: flex; align-items: baseline">
            <v-icon x-large class="mr-3" color="black">
              mdi-weather-partly-cloudy
            </v-icon>
            <p class="mb-5" style="font-size: 30pt; font-weight: 600">
              Escenarios Climaticos y Precipitación
            </p>
          </div>
          <v-row class="mb-4">
            <v-col cols="6">
              <highcharts
                class="mb-4"
                :options="chartOptionsClima"
              ></highcharts>
              <div
                style="font-size: 14pt"
                v-text="publicacion.EscenariosClimaticos.BodyTemperatura.es"
              ></div>
            </v-col>
            <v-col cols="6">
              <highcharts
                class="mb-4"
                :options="chartOptionsPrecipitacion"
              ></highcharts>
              <div
                style="font-size: 14pt"
                v-text="publicacion.EscenariosClimaticos.BodyPrecipitacion.es"
              ></div>
            </v-col>
          </v-row>
        </div>

        <!-- INDICES Y MAPA -->
        <div class="pa-4" style="border: 1px solid #e0e0e0; border-radius: 5px">
          <!-- INDICES -->
          <v-row>
            <v-col cols="12">
              <div style="display: flex; align-items: baseline">
                <v-icon x-large class="mr-3" color="black">
                  mdi-chart-donut-variant
                </v-icon>
                <p class="mb-2" style="font-size: 30pt; font-weight: 600">
                  Indices
                </p>
              </div>
              <p
                class="grey--text text--darken-2"
                style="font-style: italic; font-size: 14pt"
              >
                Selecciona un indice para mirar su comparación en el mapa:
              </p>
              <!-- INDICES DESTACADOS -->
              <div v-show="indicesDestacados.length > 0" class="mb-2">
                <v-row>
                  <v-col class="pb-2">
                    <p class="mb-0" style="font-size: 20pt; font-weight: 500">
                      Indices Destacados
                    </p>
                  </v-col>
                </v-row>
                <v-row v-for="(item, i) in indicesDestacados" :key="i">
                  <v-col cols="4">
                    <v-card
                      class="mx-1"
                      ripple
                      style="
                        border: 2px solid #616161;
                        border-left: 15px solid #ff9234;
                      "
                      outlined
                      @click="getInfoIndicador(item.data)"
                    >
                      <v-card-text
                        style="
                          height: 100%;
                          display: flex;
                          flex-direction: column;
                          justify-content: space-around;
                        "
                      >
                        <p
                          class="mb-5"
                          style="
                            font-size: 15pt;
                            color: #ff9234;
                            font-weight: 600;
                          "
                        >
                          Indice {{ item.data.Data.Name.es }}
                        </p>
                        <p class style="font-size: 30pt; font-weight: 500">
                          {{ item.data.Value }}
                        </p>
                        <p class="mb-0" style="color: #424242">Clasificación</p>
                        <p
                          class="mb-0"
                          style="font-size: 14pt; color: #424242"
                          v-if="item.data.Data.Metrics"
                        >
                          {{ item.data.Data.Metrics.Position }}/{{
                            item.data.Data.Metrics.Count
                          }}
                        </p>
                      </v-card-text>
                    </v-card>
                  </v-col>
                  <v-col cols="8">
                    <div
                      v-html="item.pub.Body.es"
                      style="font-size: 14pt"
                    ></div>
                  </v-col>
                </v-row>
              </div>
              <!-- INDICES NORMALES -->
              <div v-show="indicesNormales.length > 0" class="mb-4">
                <v-row>
                  <v-col class="mb-2">
                    <p class="mb-0" style="font-size: 20pt; font-weight: 500">
                      Indices Secundarios
                    </p>
                  </v-col>
                </v-row>

                <div style="display: flex">
                  <v-card
                    class="mx-1"
                    style="
                      width: 25%;
                      border: 2px solid #616161;
                      border-left: 15px solid #26a69a;
                    "
                    ripple
                    outlined
                    v-for="item in indicesNormales"
                    :key="item.idIndice"
                    @click="getInfoIndicador(item)"
                  >
                    <v-card-text
                      style="
                        height: 100%;
                        display: flex;
                        flex-direction: column;
                        justify-content: space-around;
                      "
                    >
                      <p
                        class="mb-5"
                        style="
                          font-size: 15pt;
                          color: #26a69a;
                          font-weight: 600;
                        "
                      >
                        Indice {{ item.Data.Name.es }}
                      </p>
                      <p class style="font-size: 30pt; font-weight: 500">
                        {{ item.Value }}
                      </p>
                      <p class="mb-0" style="color: #424242">Clasificación</p>
                      <p
                        class="mb-0"
                        style="font-size: 14pt; color: #424242"
                        v-if="item.Data.Metrics"
                      >
                        {{ item.Data.Metrics.Position }}/{{
                          item.Data.Metrics.Count
                        }}
                      </p>
                    </v-card-text>
                  </v-card>
                </div>
              </div>
            </v-col>
          </v-row>
          <!-- MAPA -->
          <v-row>
            <v-col cols="12">
              <div style="position: relative">
                <h2
                  class="mb-4"
                  v-if="indiceSelected"
                  style="text-align: center; font-weight: 600; color: #26a69a"
                >
                  Mapa Indice {{ indiceSelected.Data.Name.es }}
                </h2>

                <div
                  v-if="descripcionIndiceSelected"
                  class="mb-2"
                  style="font-size: 16pt; text-align: center; color: #757575"
                  v-html="descripcionIndiceSelected.es"
                ></div>

                <div id="map" style="height: 450px"></div>

                <div v-if="indiceSelected" id="state-legend" class="legend">
                  <h4 style="font-size: 15pt">Convenciones</h4>
                  <div>
                    <span style="background-color: #b2dfdb"></span>Valor Minimo
                  </div>
                  <div>
                    <span style="background-color: #004d40"></span>Valor Maximo
                  </div>
                </div>
              </div>
            </v-col>
          </v-row>
        </div>

        <!-- VARIABLES -->
        <v-row v-show="chartsVariables.length > 0">
          <v-col cols="12">
            <v-row v-if="dataUbication">
              <v-col cols="12">
                <div style="display: flex; align-items: baseline">
                  <v-icon x-large class="mr-3" color="black">
                    mdi-chart-line
                  </v-icon>
                  <p style="font-size: 30pt; font-weight: 600">Variables</p>
                </div>
                <v-row>
                  <v-col cols="6">
                    <div v-for="chart in chartsVariables">
                      <v-card
                        outlined
                        class="mx-2 mb-5 pt-2"
                        style="position: relative"
                      >
                        <highcharts :options="chart"></highcharts>
                        <div style="position: absolute; top: 6px; right: 6px">
                          <v-icon medium @click="showInformationVariable(chart)"
                            >mdi-information-outline</v-icon
                          >
                        </div>
                      </v-card>
                    </div>
                  </v-col>
                  <v-col cols="6">
                    <div
                      style="font-size: 14pt"
                      v-html="publicacion.Body.es.Second"
                    ></div>
                    <!-- <div
                      v-for="variable in publicacion.Variables"
                      :key="variable.Variable.Id"
                      v-html="variable.Body.es"
                    ></div>-->
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </div>
      <div v-if="publicacion.Sponsors" class="pa-4" style="border: 1px solid #e0e0e0; border-radius: 5px; margin-top: 1rem">
        <div style="display: flex; align-items: baseline">
          <v-icon x-large class="mr-3" color="black">
            mdi-handshake
          </v-icon>
          <p class="mb-2" style="font-size: 30pt; font-weight: 600">
            Socios
          </p>
        </div>
        <v-row>
          <v-col cols="12" class="pa-0">
            <v-list v-model="publicacion.Sponsors" two-line subheader style="display: flex; justify-content: space-around; flex-wrap: wrap;" class="sponsor">
              <div v-for="item in publicacion.Sponsors" :key="item.Name" style="display: flex; flex-direction: column; align-items: center; margin: 0 1rem; justify-content: space-around">
                <v-tooltip bottom color="black" style="border-radius: 50px; border: red">
                  <template v-slot:activator="{ on }">
                    <v-img :src="item.Data.url" max-width="200" max-height="200" :contain="true" v-on="on"></v-img>
                    <div style="margin: 1rem 0;"><a v-bind:href="item.Data.weburl" target="_blank" style="font-size: 22px; text-decoration: none;">{{ item.Name.toUpperCase() }}</a></div>
                  </template>
                  <div style="max-width: 200px; ">{{item.Data.description}}</div>
                </v-tooltip>
              </div>
            </v-list>
          </v-col>
        </v-row>
      </div>
      <div v-if="publicacion.Bibliografias" class="pa-4" style="border: 1px solid #e0e0e0; border-radius: 5px; margin-top: 1rem">
        <div style="display: flex; align-items: baseline">
          <v-icon x-large class="mr-3" color="black">
            mdi-fountain-pen-tip
          </v-icon>
          <p class="mb-2" style="font-size: 30pt; font-weight: 600">
            Bibliografía
          </p>
        </div>
        <v-row v-for="(item, i) in publicacion.Bibliografias" :key="i" style="padding: 2rem;">

          <a  :href="item.Url" target="_blank">
            {{item.Text}}
          </a>
        </v-row>
      </div>
      <div style= "margin-top: 2rem" >
        <v-btn style= "color: #01953B; width: 100%" icon @click="showCommentFormDialog = true">
          <div>
            <span style="font-size: 18px">Ayudanos a mejorar! dejanos un comentario </span>
            <v-icon>mdi-comment-text</v-icon>
          </div>
        </v-btn>
      </div>
      <div>
        <div style="text-align: center; font-size: 18px">
          <span style="color: #01953B">Comparte!</span>
          <br>
          <v-btn style= "margin-right: 7px; margin-top: 7px" :href="getUrlCompartir('facebook')" target="_blank">
            <v-icon style="color: #01953B" >mdi-facebook</v-icon>
          </v-btn>
          <v-btn style= "margin-right: 7px; margin-top: 7px" :href="getUrlCompartir('twitter')" target="_blank">
            <v-icon style="color: #01953B" >mdi-twitter</v-icon>
          </v-btn>
          <v-btn style= "margin-right: 7px; margin-top: 7px" :href="getUrlCompartir('whatsapp')" target="_blank">
            <v-icon style="color: #01953B" >mdi-whatsapp</v-icon>
          </v-btn>
          <v-btn style= "margin-top: 7px" :href="getUrlCompartir('linkedin')" target="_blank">
            <v-icon style="color: #01953B" >mdi-linkedin</v-icon>
          </v-btn>
        </div>
      </div>
    </v-container>
    <footer-ciat></footer-ciat>
    <!-- SELECCIONAR MUNICIPIO -->
    <v-dialog v-model="selectMunicipioDialog" persistent max-width="700px">
      <v-card>
        <v-toolbar flat color="primary" dark>
          <v-toolbar-title>Selecciona un Municipio</v-toolbar-title>
          <!-- <v-spacer></v-spacer>
          <v-btn icon @click="addIndiceDialog=false">
            <v-icon>mdi-close</v-icon>
          </v-btn>-->
        </v-toolbar>
        <v-card-text class="pb-2 pt-2">
          <v-form ref="formAddIndice">
            <v-row>
              <v-col cols="12">
                <v-autocomplete
                  v-model="municipio"
                  :items="dataForm.Cities"
                  item-text="Name"
                  item-value="Id"
                  hide-details="auto"
                  single-line
                  filled
                  return-object
                  @change="setMunicipio(municipio)"
                  rounded
                ></v-autocomplete>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <!-- <v-divider></v-divider> -->
        <!-- <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text large @click="cancelDialogAddIndice()">Cancelar</v-btn>
          <v-btn text @click="addIndice(newIndice)" large>Guardar</v-btn>
        </v-card-actions>-->
        <!-- <v-overlay :absolute="true" :value="loadingAddIndice">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>-->
      </v-card>
    </v-dialog>
    <!-- SHOW INFORMATION VARIABLE-->
    <v-dialog
      v-model="showInformationVariableDialog"
      persistent
      max-width="500px"
    >
      <v-card v-if="infoVariableSelected">
        <v-toolbar flat :color="infoVariableSelected.color">
          <v-toolbar-title>{{
            infoVariableSelected.Variable.Name.es
          }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="showInformationVariableDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="pb-2 pt-2">
          <div
            class="pa-2"
            v-html="infoVariableSelected.Body.es"
            style="font-size: 13pt; line-height: 24px"
          ></div>
        </v-card-text>
        <!-- <v-divider></v-divider> -->
        <!-- <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text large @click="cancelDialogAddIndice()">Cancelar</v-btn>
          <v-btn text @click="addIndice(newIndice)" large>Guardar</v-btn>
        </v-card-actions>-->
        <!-- <v-overlay :absolute="true" :value="loadingAddIndice">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>-->
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="showCommentFormDialog"
        max-width="500px"
      > 
        <v-toolbar flat color="primary" dark>
          <v-toolbar-title>Agregar comentario</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="() => showCommentFormDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
      <v-card
        style="padding: 1rem">
        <v-form ref="formAddComment">
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="newComment.Username"
                label="Nombre de usuario"
                outlined
                hide-details="auto"
                required
                :rules="rules"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="newComment.Email"
                label="Email"
                outlined
                rows="4"
                :rules="rules"
              ></v-text-field>
            </v-col>
            <!-- v-textarea -->
             <v-col cols="12">
              <v-textarea
                v-model="newComment.Content"
                label="Comentario"
                outlined
                rows="4"
                :rules="rules"
              ></v-textarea>
            </v-col>
          </v-row>
        </v-form>
         <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="red darken-1"
            text
            large
            @click="() => showCommentFormDialog = false"
            >Cancelar</v-btn
          >
          <v-btn text @click="addComment()" large>Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import mapboxgl from "mapbox-gl";
import api from "@/api/api";
import { jsPDF } from "jspdf";
import espacioHImg from "@/assets/img/espacio-honduras.png"
import alianzaImg from "@/assets/img/alianza.png"

var map;
let rawGeo;
let popupIndice;

import HeaderLogos from "@/components/Header";
import FooterCiat from "@/components/FooterCiat";

export default {
  name: "Publicacion",
  components: {
    HeaderLogos,
    FooterCiat,
  },
  data() {
    return {
      idPublication: null,
      publicacion: null,
      selectMunicipioDialog: false,
      dataForm: {
        Cities: [
          {
            Id: 401,
            Hash: "hn-cp-sc",
            State: { Hash: "hn-cp", Id: 4, Name: "Copán" },
            Name: "Santa Rosa de Copán",
          },
          {
            Id: 402,
            Hash: "hn-cp-ca",
            State: { Hash: "hn-cp", Id: 4, Name: "Copán" },
            Name: "Cabañas",
          },
          {
            Id: 403,
            Hash: "hn-cp-cn",
            State: { Hash: "hn-cp", Id: 4, Name: "Copán" },
            Name: "Concepción",
          },
          {
            Id: 404,
            Hash: "hn-cp-cr",
            State: { Hash: "hn-cp", Id: 4, Name: "Copán" },
            Name: "Copán Ruinas",
          },
          {
            Id: 405,
            Hash: "hn-cp-cq",
            State: { Hash: "hn-cp", Id: 4, Name: "Copán" },
            Name: "Corquín",
          },
          {
            Id: 406,
            Hash: "hn-cp-cu",
            State: { Hash: "hn-cp", Id: 4, Name: "Copán" },
            Name: "Cucuyagua",
          },
          {
            Id: 407,
            Hash: "hn-cp-do",
            State: { Hash: "hn-cp", Id: 4, Name: "Copán" },
            Name: "Dolores",
          },
          {
            Id: 408,
            Hash: "hn-cp-dn",
            State: { Hash: "hn-cp", Id: 4, Name: "Copán" },
            Name: "Dulce Nombre",
          },
          {
            Id: 409,
            Hash: "hn-cp-ep",
            State: { Hash: "hn-cp", Id: 4, Name: "Copán" },
            Name: "El Paraíso",
          },
          {
            Id: 410,
            Hash: "hn-cp-fl",
            State: { Hash: "hn-cp", Id: 4, Name: "Copán" },
            Name: "Florida",
          },
          {
            Id: 411,
            Hash: "hn-cp-lj",
            State: { Hash: "hn-cp", Id: 4, Name: "Copán" },
            Name: "La Jigua",
          },
          {
            Id: 412,
            Hash: "hn-cp-lu",
            State: { Hash: "hn-cp", Id: 4, Name: "Copán" },
            Name: "La Unión",
          },
          {
            Id: 413,
            Hash: "hn-cp-na",
            State: { Hash: "hn-cp", Id: 4, Name: "Copán" },
            Name: "Nueva Arcadia",
          },
          {
            Id: 414,
            Hash: "hn-cp-sg",
            State: { Hash: "hn-cp", Id: 4, Name: "Copán" },
            Name: "San Agustín",
          },
          {
            Id: 415,
            Hash: "hn-cp-sa",
            State: { Hash: "hn-cp", Id: 4, Name: "Copán" },
            Name: "San Antonio",
          },
          {
            Id: 416,
            Hash: "hn-cp-sm",
            State: { Hash: "hn-cp", Id: 4, Name: "Copán" },
            Name: "San Jerónimo",
          },
          {
            Id: 417,
            Hash: "hn-cp-sj",
            State: { Hash: "hn-cp", Id: 4, Name: "Copán" },
            Name: "San José",
          },
          {
            Id: 418,
            Hash: "hn-cp-so",
            State: { Hash: "hn-cp", Id: 4, Name: "Copán" },
            Name: "San Juan de Opoa",
          },
          {
            Id: 419,
            Hash: "hn-cp-sn",
            State: { Hash: "hn-cp", Id: 4, Name: "Copán" },
            Name: "San Nicolás",
          },
          {
            Id: 420,
            Hash: "hn-cp-sp",
            State: { Hash: "hn-cp", Id: 4, Name: "Copán" },
            Name: "San Pedro de Copán",
          },
          {
            Id: 421,
            Hash: "hn-cp-sr",
            State: { Hash: "hn-cp", Id: 4, Name: "Copán" },
            Name: "Santa Rita",
          },
          {
            Id: 422,
            Hash: "hn-cp-tc",
            State: { Hash: "hn-cp", Id: 4, Name: "Copán" },
            Name: "Trinidad de Copán",
          },
          {
            Id: 423,
            Hash: "hn-cp-ve",
            State: { Hash: "hn-cp", Id: 4, Name: "Copán" },
            Name: "Veracruz",
          },
          {
            Id: 601,
            Hash: "hn-ch-ch",
            State: { Hash: "hn-ch", Id: 6, Name: "Choluteca" },
            Name: "Choluteca",
          },
          {
            Id: 602,
            Hash: "hn-ch-ap",
            State: { Hash: "hn-ch", Id: 6, Name: "Choluteca" },
            Name: "Apacilagua",
          },
          {
            Id: 603,
            Hash: "hn-ch-cm",
            State: { Hash: "hn-ch", Id: 6, Name: "Choluteca" },
            Name: "Concepción de Maria",
          },
          {
            Id: 604,
            Hash: "hn-ch-du",
            State: { Hash: "hn-ch", Id: 6, Name: "Choluteca" },
            Name: "Duyure",
          },
          {
            Id: 605,
            Hash: "hn-ch-ec",
            State: { Hash: "hn-ch", Id: 6, Name: "Choluteca" },
            Name: "El Corpus",
          },
          {
            Id: 606,
            Hash: "hn-ch-et",
            State: { Hash: "hn-ch", Id: 6, Name: "Choluteca" },
            Name: "El Triunfo",
          },
          {
            Id: 607,
            Hash: "hn-ch-ma",
            State: { Hash: "hn-ch", Id: 6, Name: "Choluteca" },
            Name: "Marcovia",
          },
          {
            Id: 608,
            Hash: "hn-ch-mo",
            State: { Hash: "hn-ch", Id: 6, Name: "Choluteca" },
            Name: "Morolica",
          },
          {
            Id: 609,
            Hash: "hn-ch-na",
            State: { Hash: "hn-ch", Id: 6, Name: "Choluteca" },
            Name: "Namasigue",
          },
          {
            Id: 610,
            Hash: "hn-ch-or",
            State: { Hash: "hn-ch", Id: 6, Name: "Choluteca" },
            Name: "Orocuina",
          },
          {
            Id: 611,
            Hash: "hn-ch-pe",
            State: { Hash: "hn-ch", Id: 6, Name: "Choluteca" },
            Name: "Pespire",
          },
          {
            Id: 612,
            Hash: "hn-ch-sf",
            State: { Hash: "hn-ch", Id: 6, Name: "Choluteca" },
            Name: "San Antonio de Flores",
          },
          {
            Id: 613,
            Hash: "hn-ch-si",
            State: { Hash: "hn-ch", Id: 6, Name: "Choluteca" },
            Name: "San Isidro",
          },
          {
            Id: 614,
            Hash: "hn-ch-sj",
            State: { Hash: "hn-ch", Id: 6, Name: "Choluteca" },
            Name: "San José",
          },
          {
            Id: 615,
            Hash: "hn-ch-sm",
            State: { Hash: "hn-ch", Id: 6, Name: "Choluteca" },
            Name: "San Marcos de Colón",
          },
          {
            Id: 616,
            Hash: "hn-ch-sy",
            State: { Hash: "hn-ch", Id: 6, Name: "Choluteca" },
            Name: "Santa Ana de Yusguare",
          },
          {
            Id: 701,
            Hash: "hn-ep-yu",
            State: { Hash: "hn-ep", Id: 7, Name: "El Paraíso" },
            Name: "Yuscarán",
          },
          {
            Id: 702,
            Hash: "hn-ep-al",
            State: { Hash: "hn-ep", Id: 7, Name: "El Paraíso" },
            Name: "Alauca",
          },
          {
            Id: 705,
            Hash: "hn-ep-gu",
            State: { Hash: "hn-ep", Id: 7, Name: "El Paraíso" },
            Name: "Güinope",
          },
          {
            Id: 707,
            Hash: "hn-ep-li",
            State: { Hash: "hn-ep", Id: 7, Name: "El Paraíso" },
            Name: "Liure",
          },
          {
            Id: 708,
            Hash: "hn-ep-mo",
            State: { Hash: "hn-ep", Id: 7, Name: "El Paraíso" },
            Name: "Morocelí",
          },
          {
            Id: 709,
            Hash: "hn-ep-or",
            State: { Hash: "hn-ep", Id: 7, Name: "El Paraíso" },
            Name: "Oropolí",
          },
          {
            Id: 711,
            Hash: "hn-ep-sa",
            State: { Hash: "hn-ep", Id: 7, Name: "El Paraíso" },
            Name: "San Antonio de Flores",
          },
          {
            Id: 712,
            Hash: "hn-ep-sl",
            State: { Hash: "hn-ep", Id: 7, Name: "El Paraíso" },
            Name: "San Lucas",
          },
          {
            Id: 714,
            Hash: "hn-ep-so",
            State: { Hash: "hn-ep", Id: 7, Name: "El Paraíso" },
            Name: "Soledad",
          },
          {
            Id: 716,
            Hash: "hn-ep-tx",
            State: { Hash: "hn-ep", Id: 7, Name: "El Paraíso" },
            Name: "Texiguat",
          },
          {
            Id: 717,
            Hash: "hn-ep-va",
            State: { Hash: "hn-ep", Id: 7, Name: "El Paraíso" },
            Name: "Vado Ancho",
          },
          {
            Id: 718,
            Hash: "hn-ep-ya",
            State: { Hash: "hn-ep", Id: 7, Name: "El Paraíso" },
            Name: "Yauyupe",
          },
          {
            Id: 801,
            Hash: "hn-fm-dc",
            State: { Hash: "hn-fm", Id: 8, Name: "Francisco Morazán" },
            Name: "Distrito Central",
          },
          {
            Id: 802,
            Hash: "hn-fm-al",
            State: { Hash: "hn-fm", Id: 8, Name: "Francisco Morazán" },
            Name: "Alubarén",
          },
          {
            Id: 804,
            Hash: "hn-fm-cu",
            State: { Hash: "hn-fm", Id: 8, Name: "Francisco Morazán" },
            Name: "Curarén",
          },
          {
            Id: 807,
            Hash: "hn-fm-ll",
            State: { Hash: "hn-fm", Id: 8, Name: "Francisco Morazán" },
            Name: "La Libertad",
          },
          {
            Id: 808,
            Hash: "hn-fm-lv",
            State: { Hash: "hn-fm", Id: 8, Name: "Francisco Morazán" },
            Name: "La Venta",
          },
          {
            Id: 809,
            Hash: "hn-fm-le",
            State: { Hash: "hn-fm", Id: 8, Name: "Francisco Morazán" },
            Name: "Lepaterique",
          },
          {
            Id: 810,
            Hash: "hn-fm-mt",
            State: { Hash: "hn-fm", Id: 8, Name: "Francisco Morazán" },
            Name: "Maraita",
          },
          {
            Id: 812,
            Hash: "hn-fm-na",
            State: { Hash: "hn-fm", Id: 8, Name: "Francisco Morazán" },
            Name: "Nueva Armenia",
          },
          {
            Id: 813,
            Hash: "hn-fm-oj",
            State: { Hash: "hn-fm", Id: 8, Name: "Francisco Morazán" },
            Name: "Ojojona",
          },
          {
            Id: 815,
            Hash: "hn-fm-re",
            State: { Hash: "hn-fm", Id: 8, Name: "Francisco Morazán" },
            Name: "Reitoca",
          },
          {
            Id: 816,
            Hash: "hn-fm-sg",
            State: { Hash: "hn-fm", Id: 8, Name: "Francisco Morazán" },
            Name: "Sabanagrande",
          },
          {
            Id: 817,
            Hash: "hn-fm-so",
            State: { Hash: "hn-fm", Id: 8, Name: "Francisco Morazán" },
            Name: "San Antonio de Oriente",
          },
          {
            Id: 818,
            Hash: "hn-fm-sb",
            State: { Hash: "hn-fm", Id: 8, Name: "Francisco Morazán" },
            Name: "San Buenaventura",
          },
          {
            Id: 820,
            Hash: "hn-fm-sj",
            State: { Hash: "hn-fm", Id: 8, Name: "Francisco Morazán" },
            Name: "San Juan de Flores",
          },
          {
            Id: 821,
            Hash: "hn-fm-sm",
            State: { Hash: "hn-fm", Id: 8, Name: "Francisco Morazán" },
            Name: "San Miguelito",
          },
          {
            Id: 822,
            Hash: "hn-fm-sa",
            State: { Hash: "hn-fm", Id: 8, Name: "Francisco Morazán" },
            Name: "Santa Ana",
          },
          {
            Id: 823,
            Hash: "hn-fm-sl",
            State: { Hash: "hn-fm", Id: 8, Name: "Francisco Morazán" },
            Name: "Santa Lucía",
          },
          {
            Id: 825,
            Hash: "hn-fm-tt",
            State: { Hash: "hn-fm", Id: 8, Name: "Francisco Morazán" },
            Name: "Tatumbla",
          },
          {
            Id: 826,
            Hash: "hn-fm-va",
            State: { Hash: "hn-fm", Id: 8, Name: "Francisco Morazán" },
            Name: "Valle de Ángeles",
          },
          {
            Id: 827,
            Hash: "hn-fm-vs",
            State: { Hash: "hn-fm", Id: 8, Name: "Francisco Morazán" },
            Name: "Villa de San Francisco",
          },
          {
            Id: 1001,
            Hash: "hn-in-le",
            State: { Hash: "hn-in", Id: 10, Name: "Intibucá" },
            Name: "La Esperanza",
          },
          {
            Id: 1002,
            Hash: "hn-in-ca",
            State: { Hash: "hn-in", Id: 10, Name: "Intibucá" },
            Name: "Camasca",
          },
          {
            Id: 1003,
            Hash: "hn-in-cl",
            State: { Hash: "hn-in", Id: 10, Name: "Intibucá" },
            Name: "Colomoncagua",
          },
          {
            Id: 1004,
            Hash: "hn-in-cn",
            State: { Hash: "hn-in", Id: 10, Name: "Intibucá" },
            Name: "Concepción",
          },
          {
            Id: 1005,
            Hash: "hn-in-do",
            State: { Hash: "hn-in", Id: 10, Name: "Intibucá" },
            Name: "Dolores",
          },
          {
            Id: 1006,
            Hash: "hn-in-in",
            State: { Hash: "hn-in", Id: 10, Name: "Intibucá" },
            Name: "Intibucá",
          },
          {
            Id: 1008,
            Hash: "hn-in-md",
            State: { Hash: "hn-in", Id: 10, Name: "Intibucá" },
            Name: "Magdalena",
          },
          {
            Id: 1010,
            Hash: "hn-in-sa",
            State: { Hash: "hn-in", Id: 10, Name: "Intibucá" },
            Name: "San Antonio",
          },
          {
            Id: 1012,
            Hash: "hn-in-sj",
            State: { Hash: "hn-in", Id: 10, Name: "Intibucá" },
            Name: "San Juan",
          },
          {
            Id: 1013,
            Hash: "hn-in-ss",
            State: { Hash: "hn-in", Id: 10, Name: "Intibucá" },
            Name: "San Marcos de La Sierra",
          },
          {
            Id: 1014,
            Hash: "hn-in-sm",
            State: { Hash: "hn-in", Id: 10, Name: "Intibucá" },
            Name: "San Miguelito",
          },
          {
            Id: 1015,
            Hash: "hn-in-sl",
            State: { Hash: "hn-in", Id: 10, Name: "Intibucá" },
            Name: "Santa Lucía",
          },
          {
            Id: 1016,
            Hash: "hn-in-ya",
            State: { Hash: "hn-in", Id: 10, Name: "Intibucá" },
            Name: "Yamaranguila",
          },
          {
            Id: 1017,
            Hash: "hn-in-sf",
            State: { Hash: "hn-in", Id: 10, Name: "Intibucá" },
            Name: "San Francisco de Opalaca",
          },
          {
            Id: 1202,
            Hash: "hn-lp-ag",
            State: { Hash: "hn-lp", Id: 12, Name: "La Paz" },
            Name: "Aguanqueterique",
          },
          {
            Id: 1203,
            Hash: "hn-lp-cb",
            State: { Hash: "hn-lp", Id: 12, Name: "La Paz" },
            Name: "Cabañas",
          },
          {
            Id: 1206,
            Hash: "hn-lp-gu",
            State: { Hash: "hn-lp", Id: 12, Name: "La Paz" },
            Name: "Guajiquiro",
          },
          {
            Id: 1207,
            Hash: "hn-lp-la",
            State: { Hash: "hn-lp", Id: 12, Name: "La Paz" },
            Name: "Lauterique",
          },
          {
            Id: 1208,
            Hash: "hn-lp-ma",
            State: { Hash: "hn-lp", Id: 12, Name: "La Paz" },
            Name: "Marcala",
          },
          {
            Id: 1209,
            Hash: "hn-lp-mo",
            State: { Hash: "hn-lp", Id: 12, Name: "La Paz" },
            Name: "Mercedes de Oriente",
          },
          {
            Id: 1210,
            Hash: "hn-lp-op",
            State: { Hash: "hn-lp", Id: 12, Name: "La Paz" },
            Name: "Opatoro",
          },
          {
            Id: 1211,
            Hash: "hn-lp-sn",
            State: { Hash: "hn-lp", Id: 12, Name: "La Paz" },
            Name: "San Antonio del Norte",
          },
          {
            Id: 1213,
            Hash: "hn-lp-su",
            State: { Hash: "hn-lp", Id: 12, Name: "La Paz" },
            Name: "San Juan",
          },
          {
            Id: 1215,
            Hash: "hn-lp-sa",
            State: { Hash: "hn-lp", Id: 12, Name: "La Paz" },
            Name: "Santa Ana",
          },
          {
            Id: 1216,
            Hash: "hn-lp-se",
            State: { Hash: "hn-lp", Id: 12, Name: "La Paz" },
            Name: "Santa Elena",
          },
          {
            Id: 1219,
            Hash: "hn-lp-ya",
            State: { Hash: "hn-lp", Id: 12, Name: "La Paz" },
            Name: "Yarula",
          },
          {
            Id: 1301,
            Hash: "hn-le-gr",
            State: { Hash: "hn-le", Id: 13, Name: "Lempira" },
            Name: "Gracias",
          },
          {
            Id: 1302,
            Hash: "hn-le-be",
            State: { Hash: "hn-le", Id: 13, Name: "Lempira" },
            Name: "Belén",
          },
          {
            Id: 1303,
            Hash: "hn-le-ca",
            State: { Hash: "hn-le", Id: 13, Name: "Lempira" },
            Name: "Candelaria",
          },
          {
            Id: 1304,
            Hash: "hn-le-co",
            State: { Hash: "hn-le", Id: 13, Name: "Lempira" },
            Name: "Cololaca",
          },
          {
            Id: 1305,
            Hash: "hn-le-er",
            State: { Hash: "hn-le", Id: 13, Name: "Lempira" },
            Name: "Erandique",
          },
          {
            Id: 1306,
            Hash: "hn-le-gc",
            State: { Hash: "hn-le", Id: 13, Name: "Lempira" },
            Name: "Gualcince",
          },
          {
            Id: 1307,
            Hash: "hn-le-gt",
            State: { Hash: "hn-le", Id: 13, Name: "Lempira" },
            Name: "Guarita",
          },
          {
            Id: 1308,
            Hash: "hn-le-lc",
            State: { Hash: "hn-le", Id: 13, Name: "Lempira" },
            Name: "La Campa",
          },
          {
            Id: 1309,
            Hash: "hn-le-li",
            State: { Hash: "hn-le", Id: 13, Name: "Lempira" },
            Name: "La Iguala",
          },
          {
            Id: 1310,
            Hash: "hn-le-lf",
            State: { Hash: "hn-le", Id: 13, Name: "Lempira" },
            Name: "Las Flores",
          },
          {
            Id: 1311,
            Hash: "hn-le-lu",
            State: { Hash: "hn-le", Id: 13, Name: "Lempira" },
            Name: "La Unión",
          },
          {
            Id: 1312,
            Hash: "hn-le-lv",
            State: { Hash: "hn-le", Id: 13, Name: "Lempira" },
            Name: "La Virtud",
          },
          {
            Id: 1313,
            Hash: "hn-le-le",
            State: { Hash: "hn-le", Id: 13, Name: "Lempira" },
            Name: "Lepaera",
          },
          {
            Id: 1314,
            Hash: "hn-le-ma",
            State: { Hash: "hn-le", Id: 13, Name: "Lempira" },
            Name: "Mapulaca",
          },
          {
            Id: 1315,
            Hash: "hn-le-pi",
            State: { Hash: "hn-le", Id: 13, Name: "Lempira" },
            Name: "Piraera",
          },
          {
            Id: 1316,
            Hash: "hn-le-sa",
            State: { Hash: "hn-le", Id: 13, Name: "Lempira" },
            Name: "San Andrés",
          },
          {
            Id: 1317,
            Hash: "hn-le-sf",
            State: { Hash: "hn-le", Id: 13, Name: "Lempira" },
            Name: "San Francisco",
          },
          {
            Id: 1318,
            Hash: "hn-le-sj",
            State: { Hash: "hn-le", Id: 13, Name: "Lempira" },
            Name: "San Juan Guarita",
          },
          {
            Id: 1319,
            Hash: "hn-le-sh",
            State: { Hash: "hn-le", Id: 13, Name: "Lempira" },
            Name: "San Manuel Colohete",
          },
          {
            Id: 1320,
            Hash: "hn-le-sr",
            State: { Hash: "hn-le", Id: 13, Name: "Lempira" },
            Name: "San Rafael",
          },
          {
            Id: 1321,
            Hash: "hn-le-ss",
            State: { Hash: "hn-le", Id: 13, Name: "Lempira" },
            Name: "San Sebastián",
          },
          {
            Id: 1322,
            Hash: "hn-le-sc",
            State: { Hash: "hn-le", Id: 13, Name: "Lempira" },
            Name: "Santa Cruz",
          },
          {
            Id: 1323,
            Hash: "hn-le-tg",
            State: { Hash: "hn-le", Id: 13, Name: "Lempira" },
            Name: "Talgua",
          },
          {
            Id: 1324,
            Hash: "hn-le-tb",
            State: { Hash: "hn-le", Id: 13, Name: "Lempira" },
            Name: "Tambla",
          },
          {
            Id: 1325,
            Hash: "hn-le-to",
            State: { Hash: "hn-le", Id: 13, Name: "Lempira" },
            Name: "Tomalá",
          },
          {
            Id: 1326,
            Hash: "hn-le-va",
            State: { Hash: "hn-le", Id: 13, Name: "Lempira" },
            Name: "Valladolid",
          },
          {
            Id: 1327,
            Hash: "hn-le-vi",
            State: { Hash: "hn-le", Id: 13, Name: "Lempira" },
            Name: "Virginia",
          },
          {
            Id: 1328,
            Hash: "hn-le-sm",
            State: { Hash: "hn-le", Id: 13, Name: "Lempira" },
            Name: "San Marcos de Caiquín",
          },
          {
            Id: 1401,
            Hash: "hn-oc-oc",
            State: { Hash: "hn-oc", Id: 14, Name: "Ocotepeque" },
            Name: "Ocotepeque",
          },
          {
            Id: 1402,
            Hash: "hn-oc-bg",
            State: { Hash: "hn-oc", Id: 14, Name: "Ocotepeque" },
            Name: "Belén Gualcho",
          },
          {
            Id: 1403,
            Hash: "hn-oc-co",
            State: { Hash: "hn-oc", Id: 14, Name: "Ocotepeque" },
            Name: "Concepción",
          },
          {
            Id: 1404,
            Hash: "hn-oc-dm",
            State: { Hash: "hn-oc", Id: 14, Name: "Ocotepeque" },
            Name: "Dolores Merendón",
          },
          {
            Id: 1405,
            Hash: "hn-oc-fr",
            State: { Hash: "hn-oc", Id: 14, Name: "Ocotepeque" },
            Name: "Fraternidad",
          },
          {
            Id: 1406,
            Hash: "hn-oc-le",
            State: { Hash: "hn-oc", Id: 14, Name: "Ocotepeque" },
            Name: "La Encarnación",
          },
          {
            Id: 1407,
            Hash: "hn-oc-ll",
            State: { Hash: "hn-oc", Id: 14, Name: "Ocotepeque" },
            Name: "La Labor",
          },
          {
            Id: 1408,
            Hash: "hn-oc-lu",
            State: { Hash: "hn-oc", Id: 14, Name: "Ocotepeque" },
            Name: "Lucerna",
          },
          {
            Id: 1409,
            Hash: "hn-oc-me",
            State: { Hash: "hn-oc", Id: 14, Name: "Ocotepeque" },
            Name: "Mercedes",
          },
          {
            Id: 1410,
            Hash: "hn-oc-sf",
            State: { Hash: "hn-oc", Id: 14, Name: "Ocotepeque" },
            Name: "San Fernando",
          },
          {
            Id: 1411,
            Hash: "hn-oc-sv",
            State: { Hash: "hn-oc", Id: 14, Name: "Ocotepeque" },
            Name: "San Francisco del Valle",
          },
          {
            Id: 1412,
            Hash: "hn-oc-sj",
            State: { Hash: "hn-oc", Id: 14, Name: "Ocotepeque" },
            Name: "San Jorge",
          },
          {
            Id: 1413,
            Hash: "hn-oc-sm",
            State: { Hash: "hn-oc", Id: 14, Name: "Ocotepeque" },
            Name: "San Marcos",
          },
          {
            Id: 1414,
            Hash: "hn-oc-st",
            State: { Hash: "hn-oc", Id: 14, Name: "Ocotepeque" },
            Name: "Santa Fé",
          },
          {
            Id: 1415,
            Hash: "hn-oc-se",
            State: { Hash: "hn-oc", Id: 14, Name: "Ocotepeque" },
            Name: "Sensenti",
          },
          {
            Id: 1416,
            Hash: "hn-oc-si",
            State: { Hash: "hn-oc", Id: 14, Name: "Ocotepeque" },
            Name: "Sinuapa",
          },
          {
            Id: 1612,
            Hash: "hn-sb-il",
            State: { Hash: "hn-sb", Id: 16, Name: "Santa Bárbara" },
            Name: "Ilama",
          },
          {
            Id: 1613,
            Hash: "hn-sb-ma",
            State: { Hash: "hn-sb", Id: 16, Name: "Santa Bárbara" },
            Name: "Macuelizo",
          },
          {
            Id: 1616,
            Hash: "hn-sb-pe",
            State: { Hash: "hn-sb", Id: 16, Name: "Santa Bárbara" },
            Name: "Petoa",
          },
          {
            Id: 1628,
            Hash: "hn-sb-nf",
            State: { Hash: "hn-sb", Id: 16, Name: "Santa Bárbara" },
            Name: "Nueva Frontera",
          },
          {
            Id: 1701,
            Hash: "hn-va-na",
            State: { Hash: "hn-va", Id: 17, Name: "Valle" },
            Name: "Nacaome",
          },
          {
            Id: 1702,
            Hash: "hn-va-al",
            State: { Hash: "hn-va", Id: 17, Name: "Valle" },
            Name: "Alianza",
          },
          {
            Id: 1703,
            Hash: "hn-va-am",
            State: { Hash: "hn-va", Id: 17, Name: "Valle" },
            Name: "Amapala",
          },
          {
            Id: 1704,
            Hash: "hn-va-ar",
            State: { Hash: "hn-va", Id: 17, Name: "Valle" },
            Name: "Aramecina",
          },
          {
            Id: 1705,
            Hash: "hn-va-ca",
            State: { Hash: "hn-va", Id: 17, Name: "Valle" },
            Name: "Caridad",
          },
          {
            Id: 1706,
            Hash: "hn-va-go",
            State: { Hash: "hn-va", Id: 17, Name: "Valle" },
            Name: "Goascorán",
          },
          {
            Id: 1707,
            Hash: "hn-va-la",
            State: { Hash: "hn-va", Id: 17, Name: "Valle" },
            Name: "Langue",
          },
          {
            Id: 1708,
            Hash: "hn-va-sf",
            State: { Hash: "hn-va", Id: 17, Name: "Valle" },
            Name: "San Francisco de Coray",
          },
          {
            Id: 1709,
            Hash: "hn-va-sl",
            State: { Hash: "hn-va", Id: 17, Name: "Valle" },
            Name: "San Lorenzo",
          },
        ],
      },
      municipio: null,
      dataUbication: null,
      indiceSelected: null,
      descripcionIndiceSelected: null,
      idUbicationSelected: null,
      chartsVariables: [],
      showInformationVariableDialog: false,
      showCommentFormDialog: false,
      infoVariableSelected: null,
      newComment: {
        Email:"",
        Username:"",
        Content:"",
        PublicationId: this.$route.params.idPublication
      },
      rules: [(v) => !!v || "Este campo es requerido"],
      indicesDestacados: [],
      indicesNormales: [],
      chartType: "",
      chartOptionsClima: {
        chart: {
          style: {
            fontFamily: "Fira Sans",
          },
          height: 300,
        },
        title: {
          text: "Proyección Temperatura Año 2050",
        },
        yAxis: {
          title: {
            text: "Temperatura Promedio (°C)",
          },
        },
        xAxis: {
          categories: ["2050-1", "2050-2", "2050-3", "2050-4"],
        },
        plotOptions: {
          series: {
            // general options for all series
          },
          line: {
            dataLabels: {
              enabled: true,
            },
          },
        },
        series: [],
        credits: {
          enabled: false,
        },
      },
      chartOptionsPrecipitacion: {
        chart: {
          style: {
            fontFamily: "Fira Sans",
          },
          height: 300,
        },
        title: {
          text: "Proyección Precipitación Año 2050",
        },
        yAxis: {
          title: {
            text: "Precipitación (mm)",
          },
        },
        xAxis: {
          categories: ["2050-1", "2050-2", "2050-3", "2050-4"],
        },
        plotOptions: {
          series: {
            // general options for all series
          },
          line: {
            dataLabels: {
              enabled: true,
            },
          },
        },
        series: [],
        credits: {
          enabled: false,
        },
      },
    };
  },
  mounted() {
    const idPublication = this.$route.params.idPublication;
    this.idPublication = idPublication;
    this.getPublication(idPublication);
    let idMunicipio = this.$route.query.idMunicipio;
    if (idMunicipio) {
      this.findMunicipioQuery(idMunicipio);
    } else {
      this.selectMunicipioDialog = true;
    }
  },
  methods: {
  getUrlCompartir(redSocial) {
    let web = "https://espacioh.cultivandofuturo.com/publicaciones/" + this.idPublication + '?idMunicipio=' + this.idUbicationSelected;
    switch (redSocial) {
    case redSocial = "facebook":
      return "http://www.facebook.com/share.php?u=" + web;
      break;
    case redSocial = "twitter":
      return "https://twitter.com/intent/tweet?text="+ this.publicacion.Name.es +"&url=" + web ;
      break;
    case redSocial = "whatsapp":
      return "https://api.whatsapp.com/send?text="+ this.publicacion.Name.es + " " + web;
      break;
    default:
        return "https://www.linkedin.com/sharing/share-offsite/?url=" + web;
      break;
  }
},
    async getPublication(idPublication) {
      try {
        const data = await api.getPublication(idPublication);
        if (data.status) {
          // console.log(data.data);
          this.publicacion = data.data;
        }
      } catch (err) {
        console.log(err);
      }
    },
    async getDataPublicationByIdUbication() {
      try {
        let data = await api.getDataPublicationByIdUbication(
          this.idPublication,
          this.municipio.Id
        );

        this.idUbicationSelected = this.municipio.Id;
        this.dataUbication = data;

        let indices = data.dataIndices;

        for (const indicePub of this.publicacion.Indices) {
          if (indicePub.Destacar) {
            for (const indiceData of indices) {
              if (indiceData.IdIndice == indicePub.Indice.Id) {
                this.indicesDestacados.push({
                  pub: indicePub,
                  data: indiceData,
                });
              }
            }
          } else {
            for (const indiceData of indices) {
              if (indiceData.IdIndice == indicePub.Indice.Id) {
                this.indicesNormales.push(indiceData);
              }
            }
          }
        }

        this.getDataChart(data.dataVariables);
        if (data.dataClima) {
          this.initClimaAndPrecipitacion(data.dataClima);
        }

        this.loadMap();

        if (this.indicesDestacados.length > 0) {
          this.getInfoIndicador(this.indicesDestacados[0].data);
        }
      } catch (err) {
        console.log(err);
      }
    },
    loadMap() {
      let vm = this;

      mapboxgl.accessToken =
        "pk.eyJ1IjoiZWRpc3NvbmFndWlsYXJjZiIsImEiOiJjazZrdzE1ZnEwNWQwM25vNnhqdDMzMzY5In0.rwzuHT31-85u3B_glT1LEQ";
      map = new mapboxgl.Map({
        container: "map",
        style: "mapbox://styles/mapbox/empty-v8",
        center: [-86.257, 14.538],
        zoom: 6.5,
        interactive: false,
        // bearing: -10,
        pitch: 10,
        attributionControl: false,
      });

      map.on("load", function () {
        map.addSource("municipios", {
          type: "geojson",
          data:
            "https://s3.amazonaws.com/resources.ciat.cultivandofuturo.com/municipios-hn.json",
          generateId: true,
        });

        map.addLayer({
          id: "state-borders",
          type: "line",
          source: "municipios",
          layout: {},
          paint: {
            "line-color": "#696969",
            "line-opacity": 0.8,
            "line-width": 0.5,
          },
        });

        // Change the cursor to a pointer when the mouse is over the states layer.
        map.on("mouseenter", "fill-indices", function (e) {
          map.getCanvas().style.cursor = "pointer";
        });

        map.on("mousemove", "fill-indices", function (e) {
          var features = map.queryRenderedFeatures(e.point);

          if (features.length > 0) {
            if (popupIndice) {
              if (popupIndice.isOpen()) popupIndice.remove();
            }
            let content = `<h4>${features[0].properties.NOMBRE}</h4><p style="margin-bottom:0;font-size:12pt;">${features[0].properties.indexValue}</p>`;

            popupIndice = new mapboxgl.Popup({
              closeButton: false,
            })
              .setLngLat(e.lngLat)
              .setHTML(content)
              .addTo(map);
          }
        });

        map.on("mouseleave", "fill-indices", function () {
          map.getCanvas().style.cursor = "";
          if (popupIndice) {
            if (popupIndice.isOpen()) popupIndice.remove();
          }
        });
      });
    },
    findMunicipioQuery(idMunicipio) {
      this.municipio = this.dataForm.Cities.find(
        (city) => city.Id == idMunicipio
      );
      this.getDataPublicationByIdUbication();
    },
    setMunicipio(mun) {
      this.municipio = mun;
      this.selectMunicipioDialog = false;
      this.$router.replace({
        path: this.$route.path,
        query: { idMunicipio: mun.Id },
      });
      this.getDataPublicationByIdUbication();
    },
    initClimaAndPrecipitacion(data) {
      let series = [];
      let seriesPrecipitacion = [];

      for (const key in data.Temperatura) {
        if (key != "Unidad") {
          let color = null;

          if (key == "RCP26") {
            color = "#3EBA3E";
          } else if (key == "RCP45") {
            color = "#F0CD4F";
          } else if (key == "RCP85") {
            color = "#FA695A";
          }

          let obj = {
            name: key,
            color,
            data: [],
          };

          for (let data of data.Temperatura[key].prom) {
            obj.data.push(data.RCPValue);
          }

          series.push(obj);
        }
      }

      for (const key in data.Precipitacion) {
        if (key != "Unidad") {
          let color = null;

          if (key == "RCP26") {
            color = "#3EBA3E";
          } else if (key == "RCP45") {
            color = "#F0CD4F";
          } else if (key == "RCP85") {
            color = "#FA695A";
          }

          let objPre = {
            name: key,
            color,
            data: [],
          };

          for (let data of data.Precipitacion[key]) {
            objPre.data.push(data.RCPValue);
          }

          seriesPrecipitacion.push(objPre);
        }
      }

      this.chartOptionsClima.series = series;
      this.chartOptionsPrecipitacion.series = seriesPrecipitacion;
    },
    getDataChart(data) {
      let areas = [];

      let colors = [
        "#d92027",
        "#ff9234",
        "#ffcd3c",
        "#35d0ba",
        "#05dfd7",
        "#a3f7bf",
        "#fff591",
        "#ade498",
        "#522d5b",
        "#fb7b6b",
        "#d7385e",
      ];

      for (let variable of data) {
        
        let chartOptions = {};
        let variablePub = this.publicacion.Variables.find(
          (item) => item.Variable.Id == variable.IdVariable
        );
        if (variablePub.chartType === "Pie"){
          chartOptions = {
            idVariable: variable.IdVariable,
            chart: {
              type: variablePub.chartType.toLowerCase(),
              style: {
                fontFamily: "Fira Sans",
              },
              height: 200,
            },
            title: {
              text: variable.Data.Variable.Name.es,
            },
            tooltip: {
              pointFormat: "{point.x}: {point.y:,.2f}",
            },
            plotOptions: {
              pie: {
                allowPointSelect: true,
                cursor: 'pointer',
                dataLabels: {
                  enabled: true,
                  format: '{point.x}'
                }
              },
              areaspline: {
                fillOpacity: 0.8,
              },
              line: {
                dataLabels: {
                  enabled: true,
                },
              }, 
            },
            series: [],
            credits: {
              enabled: false,
            },
            
          }
        }
        else {
          chartOptions = {
            idVariable: variable.IdVariable,
            chart: {
              type: variablePub.chartType.toLowerCase(),
              style: {
                fontFamily: "Fira Sans",
              },
              height: 200,
            },
            title: {
              text: variable.Data.Variable.Name.es,
            },
            xAxis: {
              categories: [],
            },
            yAxis: {
              title: {
                text: `${variablePub.Variable.Unidad.Name.Plu.es} (${variablePub.Variable.Unidad.Id})`,
              },
            },
            tooltip: {
              pointFormat:
                "{series.name}: {point.y:,.2f}",
            },
            plotOptions: {
              areaspline: {
                fillOpacity: 0.8,
              },
              line: {
                dataLabels: {
                  enabled: true,
                },
              },
              pie: {
                dataLabels:{
                  format: '{point.name}'
                }
              }
            },
            series: [],
            credits: {
              enabled: false,
            },
          };
        }
        let obj = {
          showInLegend: false,
          name: variable.Data.Variable.Name.es,
          data: [],
          color: colors[Math.floor(Math.random() * colors.length)],
        };

        for (let historico of variable.Historico) {
          if (variablePub.chartType === "Pie")
            obj.data.push({x: historico[0],y: historico[1]});
          else
          {
            chartOptions.xAxis.categories.push(historico[0]);
            obj.data.push(historico[1]);
          }
        }

        chartOptions.series.push(obj);

        areas.push(chartOptions);
      }

      this.chartsVariables = areas;
    },
    async getInfoIndicador(indice) {
      this.indiceSelected = indice;

      if (map.getLayer("ubication-border")) {
        map.removeLayer("ubication-border");
      }

      if (map.getSource("ubication")) {
        map.removeSource("ubication");
      }

      if (map.getLayer("fill-indices")) {
        map.removeLayer("fill-indices");
      }

      if (map.getSource("indices")) {
        map.removeSource("indices");
      }

      let data = await api.getDataIndice(indice.IdIndice);

      let res = await api.getMunicipiosJSON();
      let dataGeo = res.data;

      let newGeo = {
        type: "FeatureCollection",
        features: [],
      };

      let geoUbication = {
        type: "FeatureCollection",
        features: [],
      };

      let min = Math.min.apply(
        null,
        data.data.map(function (item) {
          return item.Value;
        })
      );

      let max = Math.max.apply(
        null,
        data.data.map(function (item) {
          return item.Value;
        })
      );

      for (let item of data.data) {
        for (const feature of dataGeo.features) {
          if (feature.properties.COD_MUN_ == item.IdUbication) {
            feature.properties.indexName = item.Data.Name.es;
            feature.properties.indexValue = item.Value;
            newGeo.features.push(feature);
          }
          if (feature.properties.COD_MUN_ == this.idUbicationSelected) {
            geoUbication.features.push(feature);
          }
        }
      }

      map.addSource("indices", {
        type: "geojson",
        data: newGeo,
        generateId: true,
      });

      map.addLayer({
        id: "fill-indices",
        type: "fill",
        source: "indices",
        layout: {},
        paint: {
          "fill-color": [
            "interpolate",
            ["linear"],
            ["get", "indexValue"],
            min,
            "#b2dfdb",
            max,
            "#004d40",
          ],
          "fill-outline-color": "#696969",
        },
      });

      map.addSource("ubication", {
        type: "geojson",
        data: geoUbication,
        generateId: true,
      });

      map.addLayer({
        id: "ubication-border",
        type: "line",
        source: "ubication",
        layout: {},
        paint: {
          "line-color": "#dff3e4",
          "line-opacity": 0.5,
          "line-width": 1,
        },
      });

      let indicePub = this.publicacion.Indices.find(
        (item) => item.Indice.Id == indice.IdIndice
      );

      if (indicePub.Destacar) {
        this.descripcionIndiceSelected = null;
      } else {
        this.descripcionIndiceSelected = indicePub.Body;
      }
    },
    showInformationVariable(dataChart) {
      let infoVariable = this.publicacion.Variables.find(
        (item) => item.Variable.Id == dataChart.idVariable
      );

      infoVariable.color = dataChart.series[0].color;
      this.infoVariableSelected = infoVariable;

      this.showInformationVariableDialog = true;
    },
    async addComment() {
      if (this.$refs.formAddComment.validate()) {
        await api.addComment(this.newComment);
        this.showCommentFormDialog = false;
        this.$refs.formAddComment.reset();
        // }
      }
    },
    irAtras() {
      this.$router.go(-1);
    },
    print() {
      window.print();
    },
    printPublication() {

      const doc  = new jsPDF({unit:"px"});
      // Header images
      doc.addImage(espacioHImg, "png", 10, 4, 120, 60)
      doc.addImage(alianzaImg, "png", 260, 4, 160, 50)

      //Title
      doc.setFont("Helvetica","bold")
      doc.setFontSize(25)
      doc.text(this.publicacion.Name.es, 220, 90, {align: "center", maxWidth:320})

      // Subtitle
      doc.setFont("Helvetica", "normal")
      doc.setFontSize(20)
      doc.text(`Municipio ${this.municipio.Name}`, 220, 140, {align:"center", maxWidth:350})
      // Introduction
      doc.addImage(this.publicacion.Data.LinkImage, 40, 160, 170, 170)

      doc.setFontSize(14)
      doc.setTextColor("#9e9e9e")
      doc.text(this.publicacion.Introduction.es, 220, 170, {maxWidth: 180, align: "justify"})
      
      // Body

      doc.setFont("Helvetica", "bold")
      doc.setFontSize(18)
      doc.setTextColor("#000000")
      doc.text(this.publicacion.Data.InitialTitle.es, 40, 370, {maxWidth: 320})
      
      // Body
      doc.setFont("Helvetica", "normal")
      doc.setFontSize(10)
      doc.text(this.publicacion.Body.es.First.replace(/&\w;/g, "").replace(/<\/?[^>]+(>|$)/g,""), 42, 390, {maxWidth: 340, align: "justify"})

      //Escenarios climaticos
      if (this.publicacion.EscenariosClimaticos.Show){
        doc.addPage()
        doc.setFont("Helvetica", "bold")
        doc.setFontSize(18)
        doc.text(`Escenarios Climaticos y Precipitación`, 40, 40, {maxWidth: 320})

        if (this.publicacion.EscenariosClimaticos.BodyPrecipitacion) {
          doc.setFont("Helvetica", "normal")
          doc.setFontSize(12)
          doc.text(this.publicacion.EscenariosClimaticos.BodyTemperatura.es, 40, 60, {maxWidth: 160, align:"justify"})
        }
        if (this.publicacion.EscenariosClimaticos.BodyTemperatura) {
          doc.setFont("Helvetica", "normal")
          doc.setFontSize(12)
          doc.text(this.publicacion.EscenariosClimaticos.BodyPrecipitacion.es, 230, 60, {maxWidth: 160, align:"justify"})
        }
      }

      if (this.publicacion.Indices.length > 0){
        doc.setFont("Helvetica", "bold")
        doc.setFontSize(18)
        doc.text("Indices", 40, 230, {maxWidth: 320})
        if(this.publicacion.Indices[0]) {
          doc.setFont("Helvetica", "bold")
          doc.setFontSize(16)
          doc.text(this.publicacion.Indices[0].Indice.Name.es, 40, 250, {maxWidth: 320})

          doc.setFont("Helvetica", "normal")
          doc.setFontSize(11)
          doc.text(this.publicacion.Indices[0].Body.es.replace(/&\w;/g, "").replace(/<\/?[^>]+(>|$)/g,""), 40, 270, {maxWidth: 340, align:"justify"})

        }
        if(this.publicacion.Indices[1]) {
          doc.setFont("Helvetica", "bold")
          doc.setFontSize(16)
          doc.text(this.publicacion.Indices[1].Indice.Name.es, 40, 360, {maxWidth: 320})

          doc.setFont("Helvetica", "normal")
          doc.setFontSize(11)
          doc.text(this.publicacion.Indices[1].Body.es.replace(/&\w;/g, "").replace(/<\/?[^>]+(>|$)/g,""), 40, 380, {maxWidth: 340, align:"justify"})

        }
        if(this.publicacion.Indices[2]) {
          doc.setFont("Helvetica", "bold")
          doc.setFontSize(16)
          doc.text(this.publicacion.Indices[2].Indice.Name.es, 40, 490, {maxWidth: 320})

          doc.setFont("Helvetica", "normal")
          doc.setFontSize(11)
          doc.text(this.publicacion.Indices[2].Body.es.replace(/&\w;/g, "").replace(/<\/?[^>]+(>|$)/g,""), 40, 510, {maxWidth: 340, align:"justify"})

        }
      }

      // Variables
      doc.addPage()
      doc.setFont("Helvetica", "bold")
      doc.setFontSize(16)
      doc.text("Variables", 40, 40, {maxWidth: 320})
      if(this.publicacion.Body.es.Second){
        doc.setFontSize(11)
        doc.text(this.publicacion.Body.es.Second.replace(/&\w;/g, "").replace(/<\/?[^>]+(>|$)/g,""), 40, 60, {maxWidth: 340, align:"justify"})
      }
      if(this.publicacion.Variables[0]) {
          doc.setFontSize(16)
          doc.text(this.publicacion.Variables[0].Variable.Name.es, 40, 260, {maxWidth: 320})
          doc.setFont("Helvetica", "normal")
          doc.setFontSize(11)
          doc.text(this.publicacion.Variables[0].Body.es.replace(/&\w;/g, "").replace(/<\/?[^>]+(>|$)/g,""), 40, 280, {maxWidth: 340, align:"justify"})
        }
      if(this.publicacion.Variables[1]) {
          doc.setFont("Helvetica", "bold")
          doc.setFontSize(16)
          doc.text(this.publicacion.Variables[1].Variable.Name.es, 40, 370, {maxWidth: 320})

          doc.setFont("Helvetica", "normal")
          doc.setFontSize(11)
          doc.text(this.publicacion.Variables[1].Body.es.replace(/&\w;/g, "").replace(/<\/?[^>]+(>|$)/g,""), 40, 390, {maxWidth: 340, align:"justify"})
        }
      if(this.publicacion.Variables[2]) {
          doc.setFont("Helvetica", "bold")
          doc.setFontSize(16)
          doc.text(this.publicacion.Variables[1].Variable.Name.es, 40, 500, {maxWidth: 320})

          doc.setFont("Helvetica", "normal")
          doc.setFontSize(11)
          doc.text(this.publicacion.Variables[1].Body.es.replace(/&\w;/g, "").replace(/<\/?[^>]+(>|$)/g,""), 40, 520, {maxWidth: 340, align:"justify"})
        }
      doc.save(`${this.publicacion.Name.es}.pdf`)
    }
  },
  filters: {},
};
</script>
<style>
.legend {
  background-color: #fff;
  border-radius: 3px;
  bottom: 20px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  padding: 15px;
  position: absolute;
  right: 20px;
  z-index: 1;
}

.legend h4 {
  margin: 0 0 10px;
}

.legend div {
  font-size: 14pt;
}

.legend div span {
  border-radius: 2px;
  display: inline-block;
  height: 20px;
  margin-right: 10px;
  width: 40px;
}
</style>
